export enum AttributeGroup {
    ALL = 'all',
    SIZE = 'size',
    SPECIAL_ATTRIBUTE = 'special_attribute',
    WARRANTY = 'warranty',
    TIMELINE = 'timeline'
}
